import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  interviewHostDesc: {
    marginBottom: theme.spacing(2),
  },
}));
